import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  MenuItem,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Alert
} from '@mui/material';
import { useSnackbar } from 'notistack';

const MatriculaWizard = ({ onConcluir }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  
  const steps = ['Dados da Criança', 'Responsável', 'Confirmação'];

  const [formData, setFormData] = useState({
    nomeCrianca: '',
    dataNascimento: '',
    nomeResponsavel: '',
    telefone: '',
    email: '',
    grupoId: ''
  });

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      // Última etapa - concluir
      onConcluir(formData);
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value
    });
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Nome da Criança"
              value={formData.nomeCrianca}
              onChange={handleChange('nomeCrianca')}
              fullWidth
              required
            />
            <TextField
              label="Data de Nascimento"
              type="date"
              value={formData.dataNascimento}
              onChange={handleChange('dataNascimento')}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Grupo"
              select
              value={formData.grupoId}
              onChange={handleChange('grupoId')}
              fullWidth
              required
            >
              <MenuItem value="">Selecione um grupo</MenuItem>
              <MenuItem value="1">Berçário (0-1 ano)</MenuItem>
              <MenuItem value="2">Maternal (1-2 anos)</MenuItem>
              <MenuItem value="3">Jardim (2-3 anos)</MenuItem>
            </TextField>
          </Box>
        );
      case 1:
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Nome do Responsável"
              value={formData.nomeResponsavel}
              onChange={handleChange('nomeResponsavel')}
              fullWidth
              required
            />
            <TextField
              label="Telefone"
              value={formData.telefone}
              onChange={handleChange('telefone')}
              fullWidth
              required
            />
            <TextField
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange('email')}
              fullWidth
              required
            />
          </Box>
        );
      case 2:
        return (
          <Box>
            <Alert severity="info" sx={{ mb: 2 }}>
              Revise os dados antes de confirmar a matrícula
            </Alert>
            <Typography variant="body1" gutterBottom>
              <strong>Criança:</strong> {formData.nomeCrianca}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Data de Nascimento:</strong> {formData.dataNascimento}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Responsável:</strong> {formData.nomeResponsavel}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Telefone:</strong> {formData.telefone}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Email:</strong> {formData.email}
            </Typography>
          </Box>
        );
      default:
        return 'Etapa desconhecida';
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Nova Matrícula
        </Typography>
        
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{ mb: 3 }}>
          {renderStepContent(activeStep)}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
          >
            {activeStep === steps.length - 1 ? 'Concluir' : 'Próximo'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

MatriculaWizard.propTypes = {
  onConcluir: PropTypes.func.isRequired,
};

export default MatriculaWizard;